import * as React from "react";
import { SnackBarContextProvider } from "../../context";
import { FullScreenModal, IFullScreenModalProps } from "../FullScreenModal";
import { WizardContext, WizardContextProvider } from "../Wizard/Context";
import { WizardCloseConfirm } from "../WizardCloseConfirm";
import { WizardCloseSaveConfirm } from "../WizardCloseSaveConfirm";

interface IWizardWrapperProps extends Omit<IFullScreenModalProps, "OnCloseRequest"> {
    OnCloseConfirm: () => void;
    ShouldPromptSave?: boolean;
    IsDirty?: () => boolean;
}

export const WizardWrapper = (props: IWizardWrapperProps) => {
    // State
    const [isClosing, setIsClosing] = React.useState(false);

    const handleOnClose = (closeConfirm: boolean) => {
        if (closeConfirm) {
            props.OnCloseConfirm();
        } else {
            setIsClosing(false);
        }
    };

    const showCloseConfirm = () => ((props.ShouldPromptSave && props.IsDirty && props.IsDirty()) || (!props.ShouldPromptSave));

    const closeConfirmComponent = () => {
        return props.ShouldPromptSave
            ? <WizardCloseSaveConfirm SetIsClosing={handleOnClose} />
            : <WizardCloseConfirm SetIsClosing={handleOnClose} />;
    };

    return (
        <WizardContextProvider>
            {
                isClosing && closeConfirmComponent()
            }
            <WizardContext.Consumer>
                {(wizardContext) =>
                    <FullScreenModal
                        {...props}
                        DisableClose={wizardContext.IsCompleting}
                        OnCloseRequest={() => showCloseConfirm() ? setIsClosing(true) : props.OnCloseConfirm()}
                    >
                        <SnackBarContextProvider>
                            {props.children}
                        </SnackBarContextProvider>
                    </FullScreenModal>
                }
            </WizardContext.Consumer>
        </WizardContextProvider>
    );
};
